// 获取最终的状态信息

//nav状态
export const navStatus = state => state.navStatus
//中英文切换文字展示
export const qhText = state => state.qhText
//中英文切换文字展示
export const isLogin = state => state.isLogin
//用户信息
export const currentUser = state => state.currentUser
//登录方式
export const isUserLogin = state => state.isUserLogin
//定义选中的nav导航
export const navName = state => state.navName
//个人档案
export const userMsg = state => state.userMsg
//是否进入健康优选
export const isHealth = state => state.isHealth
//体检人列表
export const phyExPeoList = state => state.phyExPeoList
// 获取登录用户所有的信息
export const allUserMsg = state => state.allUserMsg
//额度明细
export const quotaDetailsList = state => state.quotaDetailsList



// WEBPACK FOOTER //
// ./src/store/getters.js